import { render, staticRenderFns } from "./VanFieldPicker.vue?vue&type=template&id=5d5212b5&scoped=true&"
import script from "./VanFieldPicker.vue?vue&type=script&lang=js&"
export * from "./VanFieldPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5212b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d5212b5')) {
      api.createRecord('5d5212b5', component.options)
    } else {
      api.reload('5d5212b5', component.options)
    }
    module.hot.accept("./VanFieldPicker.vue?vue&type=template&id=5d5212b5&scoped=true&", function () {
      api.rerender('5d5212b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VanFieldPicker.vue"
export default component.exports